import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonProps, IconButton, Tooltip } from "@mui/material";
import { Dialog } from "../../components/Dialog";
import { Table } from "../../components/Table";
import { Login } from "@mui/icons-material";
import { useAudience } from "../../hooks/useAudience";

type DialogProfileProps = {
  open: boolean;
  loadingClient?: boolean;
  onClose: () => void;
  onAddPerson: () => void;
  clients: any[];
};

function DialogProfile({
  open,
  loadingClient,
  onClose,
  onAddPerson,
  clients,
}: DialogProfileProps) {
  const navigate = useNavigate();

  const context = useAudience();

  const handleNavigateToDetails = useCallback(
    (item: any) => {
      navigate(`people/${item.id_pessoa}`, { state: item });
    },
    [navigate]
  );

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: handleClose,
      },
    ];
  }, [handleClose]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="xl"
        title={
          !context.filtroSelecionado.nameList
            ? "Clientes"
            : context.filtroSelecionado.nameList
        }
        open={open}
        actions={actions}
        onClose={handleClose}
      >
        <Table
          isLoading={loadingClient}
          search
          columnsButton
          pageSize={5}
          actions={
            !context.filtroSelecionado.nameList && [
              {
                icon: "add",
                tooltip: "Adicionar cliente",
                isFreeAction: true,
                onClick: () => onAddPerson(),
              },
            ]
          }
          columns={[
            { title: "#ID", field: "id_pessoa" },
            { title: "Nome", field: "nome" },
            { title: "Celular", field: "celular1" },
            { title: "Email", field: "email1" },
            { title: "Documento", field: "documento" },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Tooltip title="Ver detalhes" placement="top">
                  <IconButton onClick={() => handleNavigateToDetails(row)}>
                    <Login />
                  </IconButton>
                </Tooltip>
              ),
            },
          ]}
          data={clients}
        />
      </Dialog>
    </>
  );
}

export default DialogProfile;
